import React, { useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Faq = ({ faq }) => {
  useEffect(() => {
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq?.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
            ?.map((answer) => {
              if (answer.type === 'text') {
                return answer.text.map((paragraph) => `<p>${paragraph}</p>`).join('');
              } else if (answer.type === 'points') {
                const listItems = answer.text.map((point) => `<li>${point}</li>`).join('');
                return `<ul>${listItems}</ul>`;
              }
              return '';
            })
            .join('')
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [faq]);

  return (
    <div className="faq-wrapper">
      <h2 className="heading margin-top--lg margin-bottom--md">Commonly Asked Questions</h2>
      {faq?.map((item, index) => (
        <Accordion
          key={item.question}
          square
          disableGutters
          sx={{
            boxShadow: 'none',
            borderTop: index === 0 ? '1px solid #ccc' : null,
            borderBottom: '1px solid #ccc',
            '&:before': { display: 'none' }
          }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            sx={{
              minHeight: '32px',
              padding: '0px',
              '& .MuiAccordionSummary-content': {
                margin: '20px 0px'
              }
            }}>
            <p className="question">{item.question}</p>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: '0px 0px 20px 0px',
              marginTop: '-5px'
            }}>
            {item?.answer?.map((answer, i) =>
              answer.type === 'points' ? (
                <ul key={i}>
                  {answer.text.map((text) => (
                    <li className="answer" key={text}>
                      {text}
                    </li>
                  ))}
                </ul>
              ) : (
                answer.text.map((text) => (
                  <p className="answer" key={text}>
                    {text}
                  </p>
                ))
              )
            )}
          </AccordionDetails>
        </Accordion>
      ))}
      <style jsx>{`
        .faq-wrapper {
          max-width: 1000px;
          margin: auto;
        }
        .heading {
          text-align: center;
          font-weight: normal;
        }
        .question {
          font-size: 16px;
          font-weight: 600;
        }
        .answer {
          font-size: 16px;
        }
      `}</style>
    </div>
  );
};

export default Faq;
